import { DynamicModalLayerInstance } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer';

export type DynamicModalProps = {
  dynamicModalLayer: DynamicModalLayerInstance;
  dynamicModalVisible: boolean;
  type: DYNAMIC_MODAL_TYPES;
  selectedCard?: string;
};

export enum DYNAMIC_MODAL_TYPES {
  Popup = 'popup',
  FullScreen = 'fullscreen',
}
